import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import { GET_INTERACTIONS } from "./actionTypes";

import { setInteractions, apiError } from "./actions";

import axios from "axios";

function* getInteraction({ payload: { chatId } }) {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/interaction/${chatId}`,
      {
        chatId,
      }
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setInteractions(chatId, response.data.data));
    } else throw response.data;
  } catch (error) {
    yield put(apiError(chatId, "Oops! We were unable to return this information at this time, please try again in a few minutes."));
  }
}

export function* watchGetInteractions() {
  yield takeEvery(GET_INTERACTIONS, getInteraction);
}

function* authSaga() {
  yield all([fork(watchGetInteractions)]);
}

export default authSaga;
